import React, { useState, useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./Innovations.css";

import InLineOfSight from "../../../src/img/Innovations/InLineOfSight.PNG";
import MassagingBoot from "../../../src/assets/Home/massaging-boot.jpg"

export default function AboutMe(props) {
    let fadeInScreenHandler = (screen) => {
      if (screen.fadeInScreen !== props.id) return;
      Animations.animations.fadeInScreen(props.id);
    };
  
    const fadeInSubscription =
      ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

    return (
      <div
        className="innovations-container screen-container fade-in"
        id={props.id || ""}
      >
        <div className="innovations-parent">
            <ScreenHeading
                title={"Innovations"}
                subHeading={"Ideas I Have Brought To Life."}
            />
            <div className="innovations-content">
              <div className="innovation">
                <div className="innovation-title">
                  <h5>InLine Of Sight</h5>
                </div>
                <div className="innovation-img">
                  <a href="https://www.inlineofsight.net/">
                    <img
                      src={InLineOfSight}
                      alt="Failed to load image"
                    />
                  </a>
                </div>
                <div className="innovation-details">
                  <p>A mobile app that connects you directly via video with first responders to assist you over the phone before help arrives.
                     In case of emergencies like car accidents, features like voice-to-text and video call can enable victim contact 
                     and share their live location with emergency personnel, to provide instructions on how to deal with incident promptly.
                  </p>
                </div>
                <div className="project-explore">
                  <div className="project-explore-button">
                    <a href="https://inlineofsight.net/">
                      <button className="btn highlighted-btn">Explore InLine Of Sight</button>
                    </a>
                  </div>
                  <div></div>
                </div>
                <hr></hr>
              </div>
              
              <div className="innovation">
                <div className="innovation-title">
                  <h5>Massaging Boot</h5>
                </div>
                <div className="innovation-img">
                  <a href="https://forsalebyinventor.com/products/climatoes-massaging-boot/">
                    <img
                      src={MassagingBoot}
                      alt="Failed to load image"
                    />
                  </a>
                </div>
                <div className="innovation-details">
                  <p>An invention that prevents tired, aching feet at work and on-the-go. 
                    With cooling and heating features adjustable based on the needs of the user, each boot also has rechargable batteries, 
                    a roller for mobility, and a lace for proper fitting.
                    It is very handy for nurses, doctors individuals in any profession that entail lengthy shifts.
                  </p>
                </div>
                <div className="project-explore">
                  <div className="project-explore-button">
                    <a href="https://forsalebyinventor.com/products/climatoes-massaging-boot/">
                      <button className="btn highlighted-btn">Explore Massaging Boot</button>
                    </a>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>   
        </div>
      </div>
    );
}